import { Lock, LockOpen } from "lucide-react";
import { useUnlock } from "@/context/TokenDataContext";

// Immediate actual availability; only the visual reveal is staggered during the ceremony.
export const PortfolioStatus = ({ testId, celebrating }) => {
  const { isUnlocked, unlockLabel } = useUnlock();
  const Icon = isUnlocked ? LockOpen : Lock;
  return (
    <div className={`unlock-status unlock-status--compact ${isUnlocked ? "unlock-status--open" : "unlock-status--locked"} mt-auto justify-center pf-lucky-status`}
      data-testid={testId} data-state={isUnlocked ? "unlocked" : "locked"} role="status" aria-live="off">
      <span className="unlock-status__icon" aria-hidden="true"><Icon /></span>
      <span className="min-w-0 pf-lucky-status__text">
        <span className="unlock-status__label block" data-testid={`${testId}-label`}>{isUnlocked ? "UNLOCKED ✓" : "LOCKED"}</span>
        {!isUnlocked && <span className="unlock-status__hint block" data-testid={`${testId}-hint`}>UNLOCKS AT {unlockLabel}</span>}
        {celebrating && isUnlocked && <span className="pf-lucky-status__previous" aria-hidden="true" data-testid={`${testId}-previous`}>LOCKED</span>}
      </span>
    </div>
  );
};